import { ConvexError } from 'convex/values';

/**
 * The server's refusal text. ConvexError data passes through as-is; a plain Error is wrapped in
 * request metadata (and redacted to "Server Error" in production), so fall back to a generic message.
 */
export const getServerMessage = (error: unknown, fallback: string): string => {
  if (error instanceof ConvexError && typeof error.data === 'string') return error.data;
  const raw = error instanceof Error ? error.message : '';
  return raw.match(/Uncaught Error:\s*(.+?)(?:\s*Called by|\n|$)/s)?.[1]?.trim() || fallback;
};
